/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ chat: NonNullable<unknown> }} Canvas_Versions_In_ChatInputs */



/**
* | output |
* | --- |
* | "in {chat}" |
*
* @param {Canvas_Versions_In_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_in_chat = /** @type {((inputs: Canvas_Versions_In_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_In_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`in ${i?.chat}`)
	return /** @type {LocalizedString} */ (`in ${i?.chat}`)
});